/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';

export interface GetBuchungenForMitarbeiter$Json$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;
  From?: string;
  To?: string;
  IncludeDeleted?: boolean;
  IncludeInactiveMitarbeiter?: boolean;
}

export function getBuchungenForMitarbeiter$Json(http: HttpClient, rootUrl: string, params: GetBuchungenForMitarbeiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungDto>>> {
  const rb = new RequestBuilder(rootUrl, getBuchungenForMitarbeiter$Json.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.query('From', params.From, {});
    rb.query('To', params.To, {});
    rb.query('IncludeDeleted', params.IncludeDeleted, {});
    rb.query('IncludeInactiveMitarbeiter', params.IncludeInactiveMitarbeiter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungDto>>;
    })
  );
}

getBuchungenForMitarbeiter$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/buchungen';
